module.exports = __webpack_public_path__ + "07dac3ce2c66e7bb233058e601fac9c8.svg";